import { useState } from 'react';
import '../CSS_File/MainBlogPage.css';

function BlogCommentForm() {
    const [name, setName] = useState("");
    const [comment, setComment] = useState("");


    function findNameOfTheInput(e) {
        let nameValue = e.target.value;
        setName(nameValue);
    }

    function findCommentOfTheInput(e) {
        setComment(e.target.value);
    }
    return (
        <>
            <section className="formCommentSectionStartHere">
                <div className="container formCommentSectionInnerDiv">
                    <div className="row justify-content-center">
                        <div className="col-md-12 blogCommentFormSection">
                            <form name="contact-blog-comment" method="post" enctype="multipart/form-data" data-netlify="true" onSubmit="submit" id="blogCommentFrom" className="blogCommentForm">
                                <input type="hidden" name='form-name' value="contact-blog-comment" />
                                <div className="mb-3">
                                    <label htmlFor="blogName" className="form-label blogCommentFormLabel blogLabel">Name</label>
                                    <input type="text" className="form-control formInput" id="blogName" name="blogName" onChange={findNameOfTheInput} value={name} />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="blogEmail" className="form-label blogCommentFormLabel blogLabel">Email</label>
                                    <input type="email" className="form-control formInput" id="blogEmail" name="blogEmail" />
                                </div>
                                <div className="mb-4">
                                    <label htmlFor="blogComment" className="form-label blogCommentFormLabel blogLabel">Comment<span>*</span></label>
                                    <textarea className="form-control formInput" id="blogComment" rows="1" name="blogComment" required onChange={findCommentOfTheInput} value={comment}></textarea>
                                </div>
                                <div className="mb-3 postCommentButtonDiv">
                                    <button type="submit" className="postCommentButton" id="postCommentButton">Post Comment</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BlogCommentForm;